jQuery(document).ready(function($) {
	$("#views-exposed-form-teaserblok-block-1 .button").css("display", "none");

	$('#menu-toggle').on('click touchstart', function(event){
		$('body').toggleClass('main-menu-active');       
		$(this).toggleClass('active');
		$('nav.menu--main > ul > li').removeClass('open');
		jQuery(window).trigger('scroll');

		event.stopImmediatePropagation();
		event.preventDefault();
	});

	lightbox.option({
		'resizeDuration': 200,
		'wrapAround': true,
		'showImageNumberLabel': false,
		'maxWidth': 1024
	});

	$(".owl-carousel, .view-impressiefotos .view-content .views-field-field-impressiefotos .field-content").owlCarousel({		
		items:1,
		loop:true,
		navigation: true,
		autoWidth:true,
		center: false,
		autoplay: true,
		autoplayTimeout: 3000,
		dots: false,
	});
});